__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "sala-de-aula-mfe-consumer";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-v3", "0.19.0", () => (Promise.all([__webpack_require__.e(979), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(979))))));
			register("@plurall/use-person", "2.0.0", () => (__webpack_require__.e(493).then(() => (() => (__webpack_require__(2493))))));
			register("@sentry/browser", "7.119.1", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(658), __webpack_require__.e(244), __webpack_require__.e(883), __webpack_require__.e(539)]).then(() => (() => (__webpack_require__(4244))))));
			register("@sentry/browser", "7.120.4", () => (Promise.all([__webpack_require__.e(476), __webpack_require__.e(62), __webpack_require__.e(11)]).then(() => (() => (__webpack_require__(7062))))));
			register("@sentry/integrations", "7.119.1", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(790), __webpack_require__.e(658), __webpack_require__.e(267)]).then(() => (() => (__webpack_require__(4267))))));
			register("@sentry/integrations", "7.120.4", () => (Promise.all([__webpack_require__.e(790), __webpack_require__.e(476), __webpack_require__.e(753)]).then(() => (() => (__webpack_require__(753))))));
			register("@sentry/react", "7.119.1", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(720), __webpack_require__.e(318), __webpack_require__.e(443)]).then(() => (() => (__webpack_require__(7720))))));
			register("@tanstack/react-query-devtools", "5.104.0", () => (__webpack_require__.e(184).then(() => (() => (__webpack_require__(6184))))));
			register("@tanstack/react-query", "5.104.0", () => (Promise.all([__webpack_require__.e(593), __webpack_require__.e(318), __webpack_require__.e(86)]).then(() => (() => (__webpack_require__(7593))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(6710))))));
			register("goober", "2.1.19", () => (__webpack_require__.e(724).then(() => (() => (__webpack_require__(1724))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(6663))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			initExternal(5894);
			initExternal(7891);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};